import MultiSelectQuestionTemplate from '~/pages/anatomyV2/libs/components/MultiSelectQuestionTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const KindOfLearningAnatomyV2 = (props: TPageProps) => (
  <MultiSelectQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.kindOfLearning.title"
    options={[
      {
        key: 'games',
        emoji: '🎮',
        i18nKey: 'onboarding.kindOfLearning.options.games',
      },
      {
        key: 'visual',
        emoji: '✨',
        i18nKey: 'onboarding.kindOfLearning.options.visual',
      },
      {
        key: 'interactive',
        emoji: '🤚',
        i18nKey: 'onboarding.kindOfLearning.options.interactive',
      },
      {
        key: 'practical',
        emoji: '🥊',
        i18nKey: 'onboarding.kindOfLearning.options.practical',
      },
      {
        key: 'audio',
        emoji: '📢',
        i18nKey: 'onboarding.kindOfLearning.options.audio',
      },
      {
        key: 'text',
        emoji: '📄',
        i18nKey: 'onboarding.kindOfLearning.options.text',
      },
    ]}
    question="What kind of learning do you like the most?"
  />
)

export default KindOfLearningAnatomyV2
